import { QueryClient } from '@tanstack/react-query'


// Time constants for better maintainability
const TIME_CONSTANTS = {
  STALE_TIME: 1000 * 60 * 5, // 5 minutes - data considered fresh
  CACHE_TIME: 1000 * 60 * 30, // 30 minutes - garbage collection time
  REFETCH_INTERVAL: 1000 * 60 * 30, // 30 minutes - auto refetch interval
  RETRY_DELAY: 1000, // 1 second base retry delay
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data fetching behavior
      enabled: true, // Queries enabled by default (can be overridden per query)
      staleTime: TIME_CONSTANTS.STALE_TIME, // Data fresh for 5 minutes
      
      // Refetch behavior
      refetchOnMount: true, // Refetch stale data when component mounts
      refetchOnReconnect: true, // Refetch when internet reconnects
      refetchOnWindowFocus: false, // Don't refetch when window gains focus (reduces unnecessary requests)
      refetchInterval: false, // Disable automatic polling by default
      refetchIntervalInBackground: false, // Don't refetch when tab is in background
      
      // Error handling and retries
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors (client errors)
        if ((error as any)?.status >= 400 && (error as any)?.status < 500) {
          return false;
        }
        // Retry up to 3 times for other errors
        return failureCount < 3;
      },
      retryDelay: (attemptIndex) => 
        Math.min(TIME_CONSTANTS.RETRY_DELAY * Math.pow(2, attemptIndex), 30000), // Exponential backoff with max 30s
      
      // Network mode
      networkMode: "online", // Only run queries when online
    },
    mutations: {
      // Error handling for mutations
      retry: (failureCount, error) => {
        // Don't retry client errors (4xx) for mutations
        if ((error as any)?.status >= 400 && (error as any)?.status < 500) {
          return false;
        }
        // Retry once for server errors
        return failureCount < 1;
      },
      retryDelay: (attemptIndex) => 
        Math.min(TIME_CONSTANTS.RETRY_DELAY * Math.pow(2, attemptIndex), 10000), // Exponential backoff with max 10s
      
      // Network mode
      networkMode: "online"
    },
  },
});
